import React from 'react';
import { FaSort } from 'react-icons/fa';

const SortDropdown = ({ onSort, isOpen, onClose }) => {
  const handleSelect = (sortOption) => {
    onSort(sortOption);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="sort-dropdown-container">
      <div className="sort-menu">
        <div className="sort-header">Sort by</div>
        <div 
          className="sort-option" 
          onClick={() => handleSelect('default')}
        >
          Default
        </div>
        <div 
          className="sort-option" 
          onClick={() => handleSelect('newest')}
        >
          Newest
        </div>
        <div 
          className="sort-option" 
          onClick={() => handleSelect('oldest')}
        >
          Oldest
        </div>
      </div>

      <style>{`
       .sort-dropdown-container {
          position: relative;
          top: -40px;
          left: 200px;
          right: 0;
          bottom: 0px;
          z-index: 999;
        }

        .sort-menu {
          position: absolute;
          top: 60px;
          right: 120px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          min-width: 200px;
          z-index: 1000;
        }

        .sort-header {
          color: #666;
          padding: 12px 16px;
          font-size: 14px;
          border-bottom: 1px solid #eee;
        }

        .sort-option {
          padding: 12px 16px;
          cursor: pointer;
          transition: background-color 0.2s;
        }

        .sort-option:hover {
          background-color: #f8f9fa;
          border-radius: 20px;
        }
      `}</style>
    </div>
  );
};

export default SortDropdown;